import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Innovacarrentalmumbai() {



  const cardData = {
    keyword: " Innova Car Rental Mumbai ",


"headingDescription": "Royal Route Cab offers reliable and spacious Innova car rental services in Mumbai, providing a perfect travel solution for families, corporate groups, airport transfers, and outstation journeys. The Toyota Innova is one of the most preferred multi-utility vehicles known for its comfort, strong performance, and ample seating capacity for 6 to 7 passengers. Our well-maintained Innova vehicles come with professional drivers, ensuring a smooth, safe, and stress-free travel experience across Mumbai and beyond. Rental pricing for Innova in Mumbai typically starts from around ₹16 to ₹18 per km for outstation trips and ₹2500 to ₹3000 for local packages depending on duration and distance. We offer flexible booking options including hourly rentals, one-way trips, and round trips with transparent pricing and no hidden charges. With 24/7 availability and easy booking, Royal Route Cab is your trusted choice for Innova car rental in Mumbai.",

"topPlaces": [
  {
    "title": "Toyota Innova Crysta Rental in Mumbai",
    "description": "Toyota Innova Crysta is one of the most preferred rental cars in Mumbai for family trips, airport transfers, and outstation travel. It offers spacious seating, premium comfort, and a smooth ride, making it ideal for long-distance journeys and group travel."
  },
  {
    "title": "Innova Airport Transfer Service Mumbai",
    "description": "Innova car rental for Mumbai airport transfers ensures timely pickups and drop-offs with ample luggage space and comfortable seating. It is perfect for business travelers, families, and international tourists looking for a hassle-free airport commute."
  },
  {
    "title": "Innova for Outstation Travel from Mumbai",
    "description": "Innova car rental is highly popular for outstation trips from Mumbai to destinations like Pune, Nashik, Shirdi, and Lonavala. It provides comfort, safety, and reliability for long highway journeys with professional drivers."
  },
  {
    "title": "Innova for Family Tours in Mumbai",
    "description": "Innova rental services in Mumbai are ideal for family tours and group travel within and outside the city. With spacious interiors and comfortable seating, it ensures a relaxed travel experience for all passengers."
  },
  {
    "title": "Innova Rental for Corporate Travel",
    "description": "Corporate travelers in Mumbai often prefer Innova rental services for meetings, events, and business trips. It offers a professional, comfortable, and reliable travel experience for executives and teams."
  },
  {
    "title": "Innova One Way Taxi Mumbai",
    "description": "One-way Innova car rental from Mumbai is a cost-effective option for travelers going to nearby cities. It allows customers to pay only for the drop journey while enjoying a comfortable and spacious ride."
  },
  {
    "title": "Innova Round Trip Rental Mumbai",
    "description": "Round trip Innova rental services in Mumbai are ideal for weekend getaways, pilgrimages, and business tours. It includes pickup, drop, waiting time, and return journey for complete travel convenience."
  },
  {
    "title": "Luxury Innova Rental Mumbai",
    "description": "Luxury Innova rentals in Mumbai offer premium interiors, extra comfort, and professional chauffeur service. It is a popular choice for weddings, VIP travel, and special occasions."
  },
  {
    "title": "Innova Crysta for Group Travel Mumbai",
    "description": "Innova Crysta is widely used for group travel in Mumbai due to its spacious seating capacity and luggage space. It is perfect for family outings, pilgrimages, and long-distance journeys."
  },
  {
    "title": "Affordable Innova Car Rental Mumbai",
    "description": "Affordable Innova car rental services in Mumbai provide budget-friendly travel without compromising on comfort and safety. It is suitable for both local and outstation travel needs."
  }
],






services: [
  {
    name: "Innova Car Rental Mumbai",
    description: "Innova car rental Mumbai offers spacious and comfortable travel for families, groups, and corporate clients. Known for its premium seating and smooth performance, the Innova is ideal for both city and long-distance journeys. Well-maintained vehicles and professional drivers ensure safety. It guarantees a comfortable and hassle-free travel experience."
  },
  {
    name: "Innova Cab Service Mumbai",
    description: "Innova cab service Mumbai provides reliable transportation with premium MPV vehicles. This service is perfect for group travel, airport transfers, and outstation trips. Professional drivers ensure safe and timely service. It ensures a smooth and enjoyable journey."
  },
  {
    name: "Toyota Innova Rental Mumbai",
    description: "Toyota Innova rental Mumbai offers high-quality vehicles designed for comfort and durability. This service is ideal for family trips and corporate travel. Spacious interiors and powerful performance enhance long-distance journeys. It ensures a premium travel experience."
  },
  {
    name: "Innova Taxi Mumbai",
    description: "Innova taxi Mumbai provides convenient and comfortable transportation for local and outstation travel. The vehicle is known for its spacious seating and reliability. Ideal for group travel and airport transfers. It ensures a smooth ride."
  },
  {
    name: "Innova on Rent Mumbai",
    description: "Innova on rent Mumbai allows customers to hire a premium MPV for flexible travel needs. This service is suitable for personal, family, and business use. Easy booking and transparent pricing enhance convenience. It ensures a pleasant journey."
  },
  {
    name: "Innova Car Hire Mumbai",
    description: "Innova car hire Mumbai provides flexible rental options for comfortable group travel. This service is ideal for events, tours, and long-distance trips. Professional drivers ensure safe travel. It guarantees a reliable experience."
  },
  {
    name: "Innova Cab Booking Mumbai",
    description: "Innova cab booking Mumbai allows travelers to reserve their vehicle easily with flexible options. Customers can select pickup location, timing, and trip type. Instant confirmation ensures availability. It simplifies travel planning."
  },
  {
    name: "Innova Taxi Booking Online Mumbai",
    description: "Innova taxi booking online Mumbai provides a quick and convenient way to book premium MPV cabs. Customers can compare pricing and options easily. Secure payment and instant confirmation enhance convenience. It ensures hassle-free booking."
  },
  {
    name: "Innova Rental Price Mumbai",
    description: "Innova rental price Mumbai varies based on trip type, distance, and duration. Transparent pricing ensures no hidden charges. Customers can choose from budget and premium packages. It helps in planning travel efficiently. It ensures value for money."
  },
  {
    name: "Innova Taxi Fare Mumbai",
    description: "Innova taxi fare Mumbai is designed to be competitive for group travel. Fare depends on usage, distance, and travel plan. Customers receive clear pricing details before booking. It ensures cost-effective travel."
  },
  {
    name: "Innova One Way Cab Mumbai",
    description: "Innova one way cab Mumbai is a cost-effective option for travelers needing a single-side drop. This service eliminates return charges and offers flexible travel timings. Ideal for airport and outstation travel. It ensures smooth and economical travel."
  },
  {
    name: "Innova Round Trip Cab Mumbai",
    description: "Innova round trip cab Mumbai is ideal for travelers planning return journeys. This service includes pickup, drop, waiting time, and return travel. Flexible schedules make it convenient. Suitable for family trips and corporate travel. It ensures comfort and efficiency."
  },
  {
    name: "Cheap Innova Rental Mumbai",
    description: "Cheap Innova rental Mumbai offers budget-friendly options for group travel without compromising comfort and safety. This service is ideal for cost-conscious travelers. Transparent pricing ensures no hidden charges. It ensures economical travel."
  },
  {
    name: "Best Innova Cab Service Mumbai",
    description: "Best Innova cab service Mumbai ensures premium travel experience with top-quality vehicles and professional drivers. This service focuses on punctuality, safety, and customer satisfaction. It guarantees a reliable and smooth journey."
  },
  {
    name: "Innova Airport Cab Mumbai",
    description: "Innova airport cab Mumbai provides spacious and comfortable airport transfers for groups and families. This service ensures timely pickup and drop at terminals. Professional drivers ensure safe travel. It guarantees a stress-free airport experience."
  },
  {
    name: "Innova Outstation Cab Mumbai",
    description: "Innova outstation cab Mumbai offers reliable long-distance travel with spacious seating and comfort. This service is ideal for family vacations, pilgrimages, and corporate trips. Vehicles are maintained for highway performance. It ensures a safe and enjoyable journey."
  }
],

tableData: [
  ["Innova Car Rental Mumbai", "Innova Cab Service Mumbai"],
  ["Toyota Innova Rental Mumbai", "Innova Taxi Mumbai"],
  ["Innova on Rent Mumbai", "Innova Car Hire Mumbai"],
  ["Innova Cab Booking Mumbai", "Innova Taxi Booking Online Mumbai"],
  ["Innova Rental Price Mumbai", "Innova Taxi Fare Mumbai"],
  ["Innova One Way Cab Mumbai", "Innova Round Trip Cab Mumbai"],
  ["Cheap Innova Rental Mumbai", "Best Innova Cab Service Mumbai"],
  ["Innova Airport Cab Mumbai", "Innova Outstation Cab Mumbai"]
],


whychoose: [
  {
    WhyChooseheading: "Spacious Innova Car Rental in Mumbai",
    WhyChoosedescription: "Royal Route Cabs offers comfortable and spacious Innova car rental in Mumbai, ideal for family trips, corporate travel, and group journeys."
  },
  {
    WhyChooseheading: "Perfect for Long-Distance Travel",
    WhyChoosedescription: "Toyota Innova is known for its comfort, reliability, and smooth ride, making it perfect for outstation trips and long journeys."
  },
  {
    WhyChooseheading: "Professional & Experienced Drivers",
    WhyChoosedescription: "Our drivers are well-trained and experienced in city and highway routes, ensuring safe and stress-free travel."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear pricing for Innova rental including all charges with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Our Innova car rental service in Mumbai is available 24/7 for flexible travel anytime."
  },
  {
    WhyChooseheading: "Clean & Well-Maintained Vehicles",
    WhyChoosedescription: "All Innova vehicles are regularly serviced, sanitized, and maintained for a premium travel experience."
  },
  {
    WhyChooseheading: "Local & Outstation Travel Options",
    WhyChoosedescription: "Book Innova for local Mumbai travel, airport transfers, or outstation trips with customized packages."
  },
  {
    WhyChooseheading: "Trusted SUV Rental Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by customers for reliable Innova car rental in Mumbai with punctual drivers and smooth service."
  }
]

};

const faqData = [
  { question: "Do you provide Innova car rental in Mumbai?", answer: "Yes, Royal Route Cabs offers Innova car rental services in Mumbai for local and outstation travel." },
  { question: "Is Innova suitable for long-distance travel?", answer: "Yes, Innova is ideal for long-distance trips due to its comfort and spacious seating." },
  { question: "Is Innova rental available 24 hours?", answer: "Yes, our Innova rental service operates 24/7." },
  { question: "Do you provide driver with Innova rental?", answer: "Yes, all rentals include professional drivers." },
  { question: "Is pricing transparent?", answer: "Yes, we provide clear pricing with no hidden charges." },
  { question: "Do you provide airport pickup with Innova?", answer: "Yes, we offer Mumbai airport pickup and drop services with Innova cars." },
  { question: "Can I book Innova for one-way trips?", answer: "Yes, we provide one-way and round-trip booking options." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended for better availability." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we provide pickup from home, hotel, and office anywhere in Mumbai." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sagar Patil",
    feedback: "Innova car rental in Mumbai with Royal Route Cabs was very smooth and reliable. The vehicle was spacious and perfect for our family travel needs.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Joshi",
    feedback: "Excellent Innova rental experience in Mumbai. The car was clean, comfortable, and the overall service felt professional and well-managed.",
    rating: 5
  }
];














  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Innova Car Rental Mumbai",
  "image": "https://www.royalroutecabs.com/assets/images/innova-car-rental-mumbai.jpg", // replace if needed
  "description": "Book Innova car rental in Mumbai with Royal Route Cabs for spacious and comfortable travel. Ideal for family trips, airport transfers, and outstation journeys. Available for one-way and round-trip bookings with 24x7 service.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "14", // per km approx starting (adjust if needed)
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/innova-car-rental-mumbai"
  }
};





  return (
    <div>
<Helmet>
  <title>Innova Car Rental Mumbai | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Innova car rental in Mumbai with Royal Route Cabs. Spacious and comfortable taxi service for airport, local, and outstation travel. Safe, reliable & 24x7 available."
  />

  <meta
    name="keywords"
    content="innova car rental mumbai, innova cab service mumbai, toyota innova rental mumbai, innova taxi mumbai, innova on rent mumbai, innova car hire mumbai, innova cab booking mumbai, innova taxi booking online mumbai, innova rental price mumbai, innova taxi fare mumbai, innova one way cab mumbai, innova round trip cab mumbai, cheap innova rental mumbai, best innova cab service mumbai, innova airport cab mumbai, innova outstation cab mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/40.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Innovacarrentalmumbai;